function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { isArray, isObject, flattenDeep } from "lodash";

var PropertyFlatList = /*#__PURE__*/function () {
  function PropertyFlatList(target) {
    _classCallCheck(this, PropertyFlatList);

    this.target = target;
  }

  _createClass(PropertyFlatList, [{
    key: "call",
    value: function call() {
      var _this = this;

      var keys = flattenDeep(Object.keys(this.target).map(function (key) {
        return _this.compute(_this.target[key], key);
      }));
      keys.sort();
      return keys;
    }
  }, {
    key: "compute",
    value: function compute(value, path) {
      var _this2 = this;

      if (!isArray(value) && isObject(value)) {
        return Object.keys(value).map(function (key) {
          return _this2.compute(value[key], "".concat(path, ".").concat(key));
        });
      } else {
        return path;
      }
    }
  }]);

  return PropertyFlatList;
}();

export function propertyFlatList(target) {
  return new PropertyFlatList(target).call();
}